export default __webpack_public_path__ + "static/media/img_banner.1ce87519.svg";